var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 11.6666H8.16683C10.5002 11.6666 11.6668 10.4999 11.6668 8.16659V5.83325C11.6668 3.49992 10.5002 2.33325 8.16683 2.33325H5.8335C3.50016 2.33325 2.3335 3.49992 2.3335 5.83325V8.16659C2.3335 10.4999 3.50016 11.6666 5.8335 11.6666Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 11.6666H22.1668C24.5002 11.6666 25.6668 10.4999 25.6668 8.16659V5.83325C25.6668 3.49992 24.5002 2.33325 22.1668 2.33325H19.8335C17.5002 2.33325 16.3335 3.49992 16.3335 5.83325V8.16659C16.3335 10.4999 17.5002 11.6666 19.8335 11.6666Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 25.6666H22.1668C24.5002 25.6666 25.6668 24.4999 25.6668 22.1666V19.8333C25.6668 17.4999 24.5002 16.3333 22.1668 16.3333H19.8335C17.5002 16.3333 16.3335 17.4999 16.3335 19.8333V22.1666C16.3335 24.4999 17.5002 25.6666 19.8335 25.6666Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 25.6666H8.16683C10.5002 25.6666 11.6668 24.4999 11.6668 22.1666V19.8333C11.6668 17.4999 10.5002 16.3333 8.16683 16.3333H5.8335C3.50016 16.3333 2.3335 17.4999 2.3335 19.8333V22.1666C2.3335 24.4999 3.50016 25.6666 5.8335 25.6666Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu.cb3300e0.svg";
export { ForwardRef as ReactComponent };